export const INVITE_USERS_ENDPOINT = '/gateway/api/invitations/invite';
